import React, { useEffect } from "react"
import SEO from "./../utils/SEOMetaTags"
import parse from "html-react-parser"
import useResource from "../custom-hooks/useResource"
import { stringToCamelCase } from '@scrippsproduct/scripps-external-component-library/dist/utils/helpers'
import PageNotFound from './PageNotFound';
import { Loading } from '@scrippsproduct/scripps-external-component-library'

import "./../scss/PrivacyPolicy.scss"
import "./../scss/PrivacyCenter.scss"
import styles from './../scss/PrivacyCenter.module.scss'

function Compliance({ previousVersion = false, docType, slug = null }) {

    const complianceData = useResource({
        cacheName: `${stringToCamelCase(docType)}:${slug}`,
        resourceName: 'compliance',
        queryVars: { predicate: `cms.directory.paths CONTAINS '${slug}'`, includeGlobal: true },
    });

    useEffect(() => {
        if (complianceData.isError) {
            console.error(complianceData.error);
        }
    }, [complianceData.isSuccess, complianceData.isError, complianceData.error, complianceData.data]);

    if (complianceData.isSuccess && complianceData?.data?.length) {
        /**
         * If more than one entry is found, use the first one
         */
        const documentContent = complianceData.data[0];

        if (documentContent.iframe) {
            return (
                <>
                    <SEO title={`${documentContent.pageTitle} | Laff`} />
                    <content-constrainer class="content-constrainer--no-padding content-constrainer--no-border">
                        <h2 className="page-content-header">{documentContent.pageTitle}</h2>
                    </content-constrainer>
                    <section className='page-section'>
                        <content-constrainer class="content-constrainer--no-border content-constrainer--lead-container">
                            <div className={styles['ot-form__wrapper']}>
                                {documentContent.richText && parse(documentContent.richText)}
                                <iframe src={`${documentContent.iframe.url}?value=${process.env.REACT_APP_DOMAIN_NAME}`} title={documentContent.iframe.title}></iframe>
                            </div>
                        </content-constrainer>
                    </section>
                </>
            );
        } else {
            return (
                <>
                    <SEO title={`${previousVersion ? "Previous " : ""}${documentContent.pageTitle} | Laff`} />
                    <h1 className={`h1`}>LaffTV {documentContent.pageTitle}</h1>
                    <div className="page-content">
                        {documentContent.html && parse(documentContent.html)}
                    </div>
                </>
            );
        }
    } else if (complianceData.isError) {
        return (
            <section className="info-page">
                <content-constrainer>
                    <PageNotFound message={`Sorry this page no longer exists.`} page={{name: 'home', path: '/'}}/>
                </content-constrainer>
            </section>
        );
    } else {
        return (
            <>
                <SEO title={`${previousVersion ? "Previous " : ""}${docType} | Laff`} />
                <section className="info-page">
                    <content-constrainer style={{minHeight: '50vh', position: 'relative'}} class="content-constrainer--no-border">
                        <Loading message={`Loading ${docType}`} topOffset={'20%'}/>
                    </content-constrainer>
                </section>
            </>
        );
    }
}

export default Compliance;
